<template>
  <div id="more">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <div class="page-content">
    <!-- pc端 -->
    <div class="content">
      <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="fromPath">{{ fromTitle || '新闻资讯' }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ val }}</el-breadcrumb-item>
      </el-breadcrumb> 
      <ul>
        <li v-for="(item, index) in news" :key="index" @click="gotoDetail(item.id)">
          <div class="top">
            <img :src="item.img" alt="" />
          </div>
          <div class="bottom">
            <p class="date">{{ moment(item.createdate).format('YYYY-MM-DD') }}</p>
            <h3>{{ item.title }}</h3>
            <p class="desc">{{ delHtmlTag(item.content) }}</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- 移动端 -->
    <div class="content-mobile">
      <ul>
        <li v-for="(item, index) in news" :key="index" @click="gotoDetail(item.id)">
          <div class="left">
            <p class="txt">
              {{ item.title }}
            </p>
            <p class="desc">
              {{ delHtmlTag(item.content) }}
            </p>
          </div>
          <div class="right">
            <img :src="item.img" class="item-img" />
            <p class="date">
              {{ moment(item.createdate).format('YYYY-MM-DD') }}
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="9"
        background
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    </div>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import { getNewsList } from "@/api/news.js";
import { delHtmlTag } from "@/utils/index.js";
import moment from "moment";
export default {
  data() {
    return {
      pageType: this.$route.query.type,
      val: this.$route.query.val,
      news: [],
      pageNum: 1,
      fromPath: '',
      fromTitle: '',
      total: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromTitle = from.meta.title;
      vm.fromPath = from.path;
    });
  },
  methods: {
    moment,
    delHtmlTag,
    getList(){
      let param = {
          pageIndex: this.pageNum,
          pageSize: 9,
      };
      param[this.pageType] = this.val;
      getNewsList(param).then(res=>{
        this.news = res.data.list;
        this.total = res.data.total;
      })
    },
    gotoDetail(id) {
      this.$router.push("/news/newsDetail?id="+id);
    },
    handleCurrentChange(v) {
      this.pageNum = v;
      this.getList();
    },
  },
  mounted(){ 
      this.getList();
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  #more {
    font-size: 14px;
    width: 100%;
    height: 100%;
    .content {
      width: 1200px;
      margin: 0 auto;
      height: auto;

      .breadcrumb{
          color: #666666;
          line-height: 20px;
          margin-top: 20px;
          margin-bottom: 20px;
          ::v-deep{
              .el-breadcrumb__inner.is-link{
                cursor: pointer;
              }
              .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
                  color: #DA5351;
              }
          }
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        &::after {
          content: "";
          width: calc((100% - 60px) / 3);
        }
        li {
          width: calc((100% - 60px) / 3);
          margin-bottom: 30px;
          display: flex;
          flex-direction: column;
          img {
            width: 100%;
            height: 206px;
            object-fit: cover;
            vertical-align: middle;
          }
          .bottom {
            padding: 16px 20px 16px 20px;
            box-sizing: border-box;
            background-color: #fafafa;
            font-size: 14px;
            opacity: 0.73;
            border: 1px solid #e6e6e6;
            flex: 1;
          }
          p.date {
            box-sizing: border-box;
            padding: 16px 0px;
            color: #b2b2b2;
            border-bottom: 1px dotted #dddddd;
          }
          h3 {
            padding: 16px 0px;
            font-size: 18px;
            height: 18px;
            color: #222;
            white-space: nowrap;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            overflow: hidden;
            -webkit-box-orient: vertical;
          }
          p.desc {
            line-height: 25px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            word-break: break-all;
            white-space: normal;
          }
        }
      }
    }
    .content-mobile {
      display: none;
    }
    .pagination {
      margin: 10px 0px 40px;
      display: flex;
      justify-content: center;
    }
  }
}
@media screen and (max-width: 960px) {
  #more {
    // padding-top: 0.56rem;
    .content-mobile {
      padding-top: .1rem;
      li {
        height: 1.12rem;
        width: 100%;
        color: #666666;
        padding: .1rem 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        border-top: 1px solid #f1f1f1;
        align-items: center;
        display: flex;
        justify-content: space-between;
        .right {
          width: 1.2rem;
          margin-left: .32rem;
          .item-img {
            width: 100%;
            height: .68rem;
            border-radius: 0.04rem;
            margin-bottom: .1rem;
          }
          .date{
            font-size: .12rem;
            color: #666666;
            line-height: .14rem;
            text-align: right;
          }
        }
        .left {
          width: 1.91rem;
          .txt {
            font-size: 0.14rem;
            color: #222222;
            line-height: 0.2rem;
            margin-bottom: 0.04rem;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            overflow: hidden;
            -webkit-box-orient: vertical;
            word-break: break-all;
            white-space: normal;
          }
          .desc {
            font-size: 0.12rem;
            color: #999;
            line-height: 0.2rem;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            overflow: hidden;
            -webkit-box-orient: vertical;
            word-break: break-all;
            white-space: normal;
          }
        }
      }
      li:first-child{
        border-top: none;
      }
    }
    .content {
      display: none;
    }
    .pagination {
      margin: 0.2rem 0 0.1rem;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
}
</style>